"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _bookmarkContext = _interopRequireDefault(require("../context/bookmarkContext"));

var _bookmarkSettingsContext = _interopRequireDefault(require("../context/bookmarkSettingsContext"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _getStoragePos = _interopRequireDefault(require("../utils/getStoragePos"));

var _addToStorage = _interopRequireDefault(require("../utils/addToStorage"));

var _removeFromStorage = _interopRequireDefault(require("../utils/removeFromStorage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    item: {
      cursor: "pointer"
    }
  };
});

var ToggleBookmark = function ToggleBookmark(props) {
  var className = props.className,
      componentDefault = props.componentDefault,
      componentHover = props.componentHover,
      componentBookmarked = props.componentBookmarked,
      componentBookmarkedHover = props.componentBookmarkedHover,
      data = props.data,
      validationFields = props.validationFields,
      onAdded = props.onAdded,
      onRemoved = props.onRemoved;

  var _useContext = (0, _react.useContext)(_bookmarkContext.default),
      _useContext2 = _slicedToArray(_useContext, 2),
      bookmarkData = _useContext2[0],
      setBookmarkData = _useContext2[1];

  var bookmarkSettings = (0, _react.useContext)(_bookmarkSettingsContext.default)[0];
  var itemStoragePos = (0, _getStoragePos.default)(bookmarkData, data, validationFields);

  var _useState = (0, _react.useState)(itemStoragePos === -1 ? 0 : 2),
      _useState2 = _slicedToArray(_useState, 2),
      itemState = _useState2[0],
      setItemState = _useState2[1];

  var css = useStyles();
  (0, _react.useEffect)(function () {
    setItemState(itemStoragePos === -1 ? 0 : 2);
  }, [data.title, itemStoragePos]);
  var currentComponent = null;

  switch (itemState) {
    case 0:
    default:
      currentComponent = componentDefault;
      break;

    case 1:
      currentComponent = componentHover;
      break;

    case 2:
      currentComponent = componentBookmarked;
      break;

    case 3:
      currentComponent = componentBookmarkedHover;
      break;
  }

  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation(); // save validationFields in storage
    // use for comparison between server and client

    data._validationFields = validationFields;

    if (itemStoragePos === -1) {
      var newStorage = (0, _addToStorage.default)(bookmarkSettings.localStorageKey, bookmarkData, data);
      setBookmarkData(newStorage);
      if (onAdded) onAdded();
    } else {
      var _newStorage = (0, _removeFromStorage.default)(bookmarkSettings.localStorageKey, bookmarkData, data, validationFields, itemStoragePos);

      setBookmarkData(_newStorage);
      if (onRemoved) onRemoved();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.item, className),
    onClick: handleClick,
    onMouseEnter: function onMouseEnter() {
      return itemStoragePos === -1 ? setItemState(1) : setItemState(3);
    },
    onMouseLeave: function onMouseLeave() {
      return itemStoragePos === -1 ? setItemState(0) : setItemState(2);
    }
  }, currentComponent);
};

ToggleBookmark.propTypes = {
  className: _propTypes.default.any,
  componentBookmarked: _propTypes.default.object.isRequired,
  componentBookmarkedHover: _propTypes.default.object.isRequired,
  componentDefault: _propTypes.default.object.isRequired,
  componentHover: _propTypes.default.object.isRequired,
  data: _propTypes.default.object.isRequired,
  validationFields: _propTypes.default.array.isRequired
};
var _default = ToggleBookmark;
exports.default = _default;